import React from 'react';
import InfoBox from '../../../widgets/InfoBox/InfoBox';
import PropTypes from 'prop-types';
import Subheader from 'material-ui/Subheader';
import { Paper } from '@material-ui/core';
import { AssignmentTurnedIn } from '@material-ui/icons';
import './DashboardPage.css';
import MRSActionPanel from './MRSActionPanel';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { MANAGED_RESTROOM_SERVICES_URL } from '../../../../route-names';
import { injectIntl } from 'react-intl';
import { faSoap } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const DashboardPage = (props) => {
  return (
    <Paper style={{ margin: 15 }}>
      <Subheader className="dashboard-section-subheader">
        <FontAwesomeIcon icon={faSoap} style={{ marginRight: 10 }} />
        {props.intl.formatMessage({
          id: 'mrs'
        })}
      </Subheader>
      <div className="main-paper-layout">
        <div className="info-boxes m-b-15" style={{ maxWidth: 250 }}>
          <Link
            to={`${MANAGED_RESTROOM_SERVICES_URL}?statuses=APPROVAL_REQUIRED&title=${props.intl.formatMessage(
              {
                id: 'customer_table_approval_required.title'
              }
            )}`}
          >
            <InfoBox
              icon={
                <AssignmentTurnedIn
                  style={{ color: '#ecbb43' }}
                  className="icon-box-icon-image material-icons"
                />
              }
              color="#F0AB00"
              title={props.intl.formatMessage({
                id: 'requiring_approval.title'
              })}
              value={props.mrsRequiringActionCount}
            />
          </Link>
        </div>
      </div>
      {!!props.ordersRequiringApproval ? (
        <MRSActionPanel orders={props.ordersRequiringApproval} />
      ) : null}
    </Paper>
  );
};

DashboardPage.propTypes = {
  mrsRequiringActionCount: PropTypes.number
};

const mapStateToProps = (state) => ({
  appStore: state.get('app').toJS()
});

export default injectIntl(connect(mapStateToProps)(DashboardPage));
